import * as React from 'react'
import { chakra } from '../../chakra'
import { AXLEHIRELogo } from './Axlehire'
import { CanadaPostLogo } from './CanadaPost'
import { CDLLogo } from './CDL'
import { DHLLogo } from './DHL'
import { EPGLogo } from './EPG'
import { FedExLogo } from './FedEx'
import { LASERSHIPLogo } from './Lasership'
import { OSMLogo } from './OSM'
import { PASSPORTGLOBALLogo } from './PassportGlobal'
import { PurolatorLogo } from './Purolator'
import { SFExpressLogo } from './SFExpress'
import type { CarrierLogoProps } from './types'
import { UDSLogo } from './UDS'
import { UniUniLogo } from './UniUni'
import { UPSLogo } from './UPS'
import { USPSLogo } from './USPS'
import { VEHOLogo } from './Veho'
import { VESYLSelectLogo } from './VESYLSelect'
import { WizmoLogo } from './Wizmo'
import { SpeedXLogo } from './SpeedX'

export type { CarrierLogoProps } from './types'

export interface CarrierLogoWithCodeProps extends CarrierLogoProps {
  carrier: string
}

// Fallback logo for unknown carriers
const UnknownLogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function UnknownLogo(props, ref) {
    const { w, width, ...restProps } = props
    // Default to w="4" (16px)
    const computedWidth = w !== undefined ? w : width !== undefined ? width : '4'

    return (
      <chakra.svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        color="fg.muted"
        w={computedWidth}
        {...restProps}
        ref={ref}
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <path d="M12 17h.01" />
      </chakra.svg>
    )
  },
)

const CARRIER_MAP: Record<string, React.ComponentType<CarrierLogoProps>> = {
  UPS: UPSLogo,
  UPSDAP: UPSLogo,
  UPSMAILINNOVATIONS: UPSLogo,
  UPSSUREPOST: UPSLogo,
  USPS: USPSLogo,
  FEDEX: FedExLogo,
  FEDEXSMARTPOST: FedExLogo,
  OSM: OSMLogo,
  OSMWORLDWIDE: OSMLogo,
  DHL: DHLLogo,
  DHLEXPRESS: DHLLogo,
  DHLECOMMERCE: DHLLogo,
  CDL: CDLLogo,
  COLUMBUSLASTMILE: CDLLogo,
  EPG: EPGLogo,
  RRDONNELLEY: EPGLogo,
  LASERSHIP: LASERSHIPLogo,
  UDS: UDSLogo,
  UNITEDDELIVERYSERVICE: UDSLogo,
  VEHO: VEHOLogo,
  AXLEHIRE: AXLEHIRELogo,
  PASSPORTGLOBAL: PASSPORTGLOBALLogo,
  UNIUNI: UniUniLogo,
  PUROLATOR: PurolatorLogo,
  SFEXPRESS: SFExpressLogo,
  CANADAPOST: CanadaPostLogo,
  WIZMO: WizmoLogo,
  SPEEDX: SpeedXLogo,
  VESYLSELECT: VESYLSelectLogo,
}

export const CarrierLogo = ({ carrier, ...props }: CarrierLogoWithCodeProps) => {
  const Logo = CARRIER_MAP[carrier?.toUpperCase()]

  if (Logo) {
    return <Logo {...props} />
  }

  // Fallback for unknown carriers
  return <UnknownLogo {...props} />
}
